import {
    APP_DIALOG_SHIFT_DETAILS_OPEN,
    APP_DIALOG_SHIFT_DETAILS_CLOSE,
    APP_DIALOG_ADD_SHIFT_OPEN, APP_DIALOG_ADD_SHIFT_CLOSE
} from "../config/actions";

export function appDialogShiftDetailsOpen(shiftId) {
    return {
        type: APP_DIALOG_SHIFT_DETAILS_OPEN,
        shiftId: shiftId
    }
}

export function appDialogShiftDetailsClose() {
    return {
        type: APP_DIALOG_SHIFT_DETAILS_CLOSE
    }
}

export function appDialogAddShiftOpen() {
    return {
        type: APP_DIALOG_ADD_SHIFT_OPEN
    }
}

export function appDialogAddShiftClose() {
    return {
        type: APP_DIALOG_ADD_SHIFT_CLOSE
    }
}
